// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { z } from 'zod';

export const projectStartClassificationSchema = z.enum([
  'renewal',
  'expansion',
  'new-business',
]);

export type ProjectStartClassification = z.infer<
  typeof projectStartClassificationSchema
>;

export const PROJECT_START_CLASSIFICATIONS =
  projectStartClassificationSchema.options;

export const PROJECT_START_CLASSIFICATION_LABELS: Record<
  ProjectStartClassification,
  string
> = {
  renewal: 'Renewal',
  expansion: 'Expansion',
  'new-business': 'New business',
};
